module.exports = __webpack_public_path__ + "img/9_newYouth_ljx.fe469a65.png";